import { Button } from '@astral/ui';
import { useAuth } from '../../providers/AuthProvider.js';
import { useT } from '../../providers/I18nProvider.js';

/** Shown when sign-in fails; offers a retry. */
export function ErrorScreen(): JSX.Element {
  const t = useT();
  const { error, login } = useAuth();
  return (
    <div className="status-screen">
      <div className="status-screen__logo">⚠️</div>
      <div className="status-screen__title">{t('auth.failed')}</div>
      <div className="status-screen__text muted">{error ?? t('errors.generic')}</div>
      <Button onClick={() => void login()}>{t('auth.retry')}</Button>
    </div>
  );
}
